<ion-content [fullscreen]="true">
  <div class="container" [formGroup]="formLogin">
    <div class="logo">
      <ion-img class="small" src="assets/logo-small.png"></ion-img>
      <ion-img aria-hidden="true" src="assets/logo.png"></ion-img>
    </div>
    <input type="text" placeholder="Login" name="email" formControlName="email">
    <input type="password" (keyup.enter)="submit()" placeholder="Senha" formControlName="password">
    <button class="btn" [disabled]="!formLogin.valid" (click)="submit()">Entrar</button>
    <p>Não possui conta? <a (click)="sendTo()">Cadastre-se</a></p>
    <p (click)="openModalForgot()" style="margin-bottom: 20px; cursor: pointer;">Esqueci minha senha</p>

    <p>{{ version }}</p>
  </div>
</ion-content>
